<template>
  <!-- 配了 logo 图就用图；没配或图挂了，画内置的口袋字标 -->
  <span class="f-brand" :class="['on-' + tone, size]">
    <img v-if="showLogo" class="f-logo" :src="logo" :alt="name" @error="logoError = true" />
    <template v-else>
      <svg class="f-pocket" viewBox="0 0 64 64" aria-hidden="true">
        <path d="M8 12h48v22c0 13-10.7 22-24 22S8 47 8 34z" fill="#FF6B2C" />
        <path d="M8 12h48v8H8z" :fill="tone === 'dark' ? '#FFF8EF' : '#2B1630'" />
        <path d="M35 22 24 38h8l-3 12 11-17h-8z" fill="#FFC93C" />
      </svg>
      <span class="f-word" v-if="!markOnly">{{ name }}</span>
    </template>
  </span>
</template>

<script>
import env from '@/assets/js/env'

export default {
  props: {
    // light：浅底上用；dark：深底上用（口袋缝线和字变成奶油色）
    tone: { type: String, default: 'light' },
    size: { type: String, default: '' },
    markOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      logo: env.logo,
      logoError: false,
      name: env.siteName || env.brand || env.brandName,
    }
  },
  computed: {
    showLogo() {
      return !!this.logo && !this.logoError
    },
  },
}
</script>
